import { observer } from 'mobx-react';
import selectEventDuration from '../actions/selectEventDuration';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import * as React from 'react';
import strings from 'owa-strings/owa-options-strings';
import createEventDurationDropdownOptions from '../utils/createEventDurationDropdownOptions';
import { getMeetingDuration } from '../selectors/getMeetingDuration';
/**
 * Specifies the default meeting duration as dropdown options.
 * Valid dropdown options - 15, 25, 30, 45, 55, 60 minutes
 * Provides support for rendering a custom meeting duration in the dropdown
 */
var dropdownOptions;
export default observer(function EventDurationSelection() {
    var defaultMeetingDuration = getMeetingDuration();
    var fetchDropdownOptions = function (defaultMeetingDuration) {
        if (!dropdownOptions) {
            dropdownOptions = createEventDurationDropdownOptions(defaultMeetingDuration);
        }
        return dropdownOptions;
    };
    var onEventDurationChange = function (option) {
        selectEventDuration(option.key);
    };
    return (React.createElement("div", null,
        React.createElement(Dropdown, { selectedKey: defaultMeetingDuration, label: strings.options_default_event_length, options: fetchDropdownOptions(defaultMeetingDuration), onChanged: onEventDurationChange })));
});
//# sourceMappingURL=EventDurationSelection.js.map